module.exports = __webpack_public_path__ + "static/media/oats.29934a90.jpg";